"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transactionsSlice = exports.toggleTransactionList = exports.removePausedTransactions = exports.fetchListCustomerTransactions = exports.default = exports.DEFAULT_TRANSACTIONS_NUMBER = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _api = require("../api");
const DEFAULT_TRANSACTIONS_NUMBER = exports.DEFAULT_TRANSACTIONS_NUMBER = 3;
const initialState = {
  transactions: [],
  error: [],
  showToggleButton: false,
  loading: false,
  isListExpanded: false
};
const fetchListCustomerTransactions = exports.fetchListCustomerTransactions = (0, _toolkit.createAsyncThunk)('transactions/listCustomerTransactions', async (_, _ref) => {
  let {
    rejectWithValue
  } = _ref;
  try {
    const {
      items
    } = await (0, _api.listCustomerTransactions)();
    return items;
  } catch (error) {
    return rejectWithValue(error.message);
  }
});
const transactionsSlice = exports.transactionsSlice = (0, _toolkit.createSlice)({
  name: 'transactions',
  initialState,
  reducers: {
    toggleTransactionList(state) {
      state.isListExpanded = !state.isListExpanded;
    },
    removePausedTransactions(state, _ref2) {
      let {
        payload
      } = _ref2;
      state.transactions = state.transactions.filter(_ref3 => {
        let {
          offerId
        } = _ref3;
        return !payload.includes(offerId);
      });
      state.showToggleButton = state.transactions.length > DEFAULT_TRANSACTIONS_NUMBER;
    }
  },
  extraReducers: {
    [fetchListCustomerTransactions.pending]: state => {
      state.loading = true;
    },
    [fetchListCustomerTransactions.fulfilled]: (state, _ref4) => {
      let {
        payload
      } = _ref4;
      state.loading = false;
      state.transactions = payload;
      state.showToggleButton = payload.length > DEFAULT_TRANSACTIONS_NUMBER;
    },
    [fetchListCustomerTransactions.rejected]: (state, _ref5) => {
      let {
        payload
      } = _ref5;
      state.loading = false;
      state.error = payload;
    }
  }
});
const {
  toggleTransactionList,
  removePausedTransactions
} = transactionsSlice.actions;
exports.removePausedTransactions = removePausedTransactions;
exports.toggleTransactionList = toggleTransactionList;
var _default = exports.default = transactionsSlice.reducer;